import { useEffect, useRef, useState } from 'react'

import { FormatPainterOutlined } from '@ant-design/icons'
import { mergeRegister } from '@lexical/utils'
import { Flex } from 'antd'
import { COMMAND_PRIORITY_EDITOR } from 'lexical'

import { useEditor } from '../../hooks/useEditor'
import {
  CANCEL_FORMAT_PAINT_COMMAND,
  DONE_FORMAT_PAINT_COMMAND,
  START_FORMAT_PAINT_COMMAND
} from '../../plugins/FormatPainterPlugin/commands'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

export const FormatPainterButton = () => {
  const editor = useEditor()
  const onceRef = useRef(false)
  const [actived, setActived] = useState(false)

  const handleClick = () => {
    if (actived) {
      editor.dispatchCommand(CANCEL_FORMAT_PAINT_COMMAND, undefined)
      return
    }
    onceRef.current = true
    editor.dispatchCommand(START_FORMAT_PAINT_COMMAND, undefined)
  }

  const handleDoubleClick = () => {
    if (actived) {
      return
    }
    onceRef.current = false
    editor.dispatchCommand(START_FORMAT_PAINT_COMMAND, undefined)
  }

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        START_FORMAT_PAINT_COMMAND,
        () => {
          setActived(true)
          return false
        },
        COMMAND_PRIORITY_EDITOR
      ),
      editor.registerCommand(
        CANCEL_FORMAT_PAINT_COMMAND,
        () => {
          setActived(false)
          return false
        },
        COMMAND_PRIORITY_EDITOR
      ),
      editor.registerCommand(
        DONE_FORMAT_PAINT_COMMAND,
        () => {
          if (onceRef.current) {
            editor.dispatchCommand(CANCEL_FORMAT_PAINT_COMMAND, undefined)
          }
          return false
        },
        COMMAND_PRIORITY_EDITOR
      )
    )
  }, [editor])

  useEffect(() => {}, [actived])

  return (
    <MenuButton
      actived={actived}
      tooltip={
        <Flex vertical align='center'>
          <span>格式刷</span>
          <span>{SHORTCUTS.FORMAT_PAINTER}</span>
        </Flex>
      }
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    >
      <FormatPainterOutlined />
    </MenuButton>
  )
}
